<template>
  <div>
    <dropdown-menu
      :id="menuId"
      align-right
      hide-chevron
    >
      <template v-slot:button>
        <dots-vertical-icon />
      </template>

      <li>
        <button
          type="button"
          class="btn btn-transparent"
          @click="reportItem"
        >
          Report
        </button>
      </li>
      <li
        v-if="userData.id === current_object.user.id"
      >
        <button
          type="button"
          class="btn btn-transparent"
          @click="deleteItem"
        >
          Delete
        </button>
      </li>
      <li
        v-else-if="isAdmin"
      >
        <button
          type="button"
          class="btn btn-transparent"
          @click="adminRemoveItem"
        >
          <img
            src="@/assets/icon.svg"
            class="tiny-icon"
          >
          Remove
        </button>
      </li>
      <li
        v-if="userData.id === current_object.user.id"
      >
        <button
          type="button"
          class="btn btn-transparent"
          @click="editItem"
        >
          Edit
        </button>
      </li>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from '@/components/DropdownMenu.vue';

export default {
  components: {
    DropdownMenu,
  },
  props: {
    listing: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    looking: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    post: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    comment: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    parentId: {
      type: [Object, Number],
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      menuId: '',
      type: '',
    };
  },
  computed: {
    isAdmin() {
      return (this.userData && this.userData.is_staff)
        || (this.membership && this.membership.is_admin);
    },
    membership() {
      let gid = null;
      if (this.type === 'comment') {
        gid = this.comment.group;
      } else {
        gid = this.current_object.group;
      }
      return this.userGroups.find(g => g.id === gid);
    },
    userData() {
      return this.$store.state.userData;
    },
    current_object() {
      let curObj = {};
      if (this.type === 'listing') {
        curObj = this.listing;
      } else if (this.type === 'looking') {
        curObj = this.looking;
      } else if (this.type === 'post') {
        curObj = this.post;
      } else {
        curObj = this.comment;
      }
      return curObj;
    },
  },
  created() {
    if (this.listing.id !== undefined) {
      this.type = 'listing';
      this.menuId = `menu-listing-${this.listing.id}`;
    } else if (this.looking.id !== undefined) {
      this.type = 'looking';
      this.menuId = `menu-looking-${this.looking.id}`;
    } else if (this.post.id !== undefined) {
      this.type = 'post';
      this.menuId = `menu-post-${this.post.id}`;
    } else {
      this.type = 'comment';
      this.menuId = `menu-comment-${this.comment.id}`;
    }
  },
  methods: {
    async adminRemoveItem() {
      if (window.confirm(`Are you sure you want to remove this ${this.type}?`)) {
        let url = `posts/${this.current_object.id}/banish/`;
        if (this.type === 'comment') {
          url = `comments/${this.current_object.id}/banish/`;
        }

        const responseData = await this.api({
          url,
          method: 'POST',
        });

        if (responseData.status === 200) {
          if (this.type === 'comment') {
            this.$store.dispatch('update_post', { id: this.parentId });
          } else {
            this.$store.dispatch('delete_post', { id: this.current_object.id });
          }
          alert(`The ${this.type} has been removed.`);
        } else {
          alert(
            `Unable to remove this ${this.type}. Please check your `
            + 'connection and try again.',
          );
        }
      }
    },
    async reportItem() {
      if (window.confirm(`Are you sure you want to report this ${this.type}?`)) {
        let url = `posts/${this.current_object.id}/report/`;
        if (this.type === 'comment') {
          url = `comments/${this.current_object.id}/report/`;
        }

        const responseData = await this.api({
          url,
          method: 'POST',
        });

        if (responseData.status === 200) {
          alert(`The ${this.type} has been reported.`);
        } else {
          alert(
            `Unable to report this ${this.type}. Please check your `
            + 'connection and try again.',
          );
        }
      }
    },
    async deleteItem() {
      if (window.confirm(`Are you sure you want to delete this ${this.type}?`)) {
        let url = `posts/${this.current_object.id}/`;
        if (this.type === 'comment') {
          url = `comments/${this.current_object.id}/`;
        }

        const responseData = await this.api({
          url,
          method: 'DELETE',
        });

        if (responseData.status === 204) {
          if (this.type === 'comment') {
            this.$store.dispatch('update_post', { id: this.parentId });
          } else {
            this.$store.dispatch('delete_post', { id: this.current_object.id });
          }
        } else {
          alert(
            `Unable to delete this ${this.type}. Please check your `
            + 'connection and try again.',
          );
        }
      }
    },
    editItem() {
      if (this.type === 'comment') {
        this.$emit('editItem');
      } else {
        this.$router.push(`/post/${this.current_object.id}/edit`);
      }
    },
  },
};
</script>
